import {
  getDocs
} from "firebase/firestore";

export async function getQueryAllData(query, successCb = null, failCb = null) {
  const querySnapshot = await getDocs(query)
  // .catch((error) => {
  //   console.log("Error getting documents: ", error);
  //   if (failCb) {
  //     failCb(error);
  //   }
  // });
  return new Promise((resolve, reject) => {
    let allDocs = [];
    querySnapshot.forEach((doc) => {
      let data = doc.data();
      data.storageDocumentId = doc.id;
      return allDocs.push(data);
    });
    if (successCb) {
      successCb(allDocs);
    }
    resolve(allDocs);
  });
}